import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosemin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "closemin",
		d: "M13,26A13,13,0,0,1,3.808,3.807,13,13,0,0,1,22.193,22.194,12.916,12.916,0,0,1,13,26ZM13,1.625A11.375,11.375,0,0,0,4.957,21.043,11.375,11.375,0,1,0,21.043,4.957,11.3,11.3,0,0,0,13,1.625ZM8.96,17.861a.818.818,0,0,1-.579-1.4l3.466-3.469L8.4,9.555A.814.814,0,1,1,9.553,8.4L13,11.846l3.492-3.494a.82.82,0,0,1,1.158,1.162l-3.491,3.494L17.6,16.445a.814.814,0,1,1-1.15,1.154L13,14.154,9.538,17.623A.817.817,0,0,1,8.96,17.861Z",
		fill: "#d7373f"
	})]
});
const ForwardRef = forwardRef(SvgClosemin);
export { ForwardRef as ReactComponent };
